module.exports = __webpack_public_path__ + "img/1.573e5cc7.jpg";